import { Component, OnInit, Input } from '@angular/core';
import { Route, ArrDepSelection } from 'src/app/_models/view/route';
import { optionsUI } from 'src/app/utils/optionsUI';
import { RouteService } from 'src/app/services/route.service';
import { DateTime } from 'luxon';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { SubscriptionLevel } from 'src/app/auth/models/user';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormGroup, FormControl } from '@angular/forms';
import { TimeField } from '../time-field/TimeField';

@Component({
  selector: 'arrive-depart-option',
  templateUrl: './arrive-depart.component.html',
})
export class RoutePanelArriveDepartComponent implements OnInit {
  @Input() route: Route;
  isPremium$: Observable<boolean>;
  optionsUI = optionsUI;
  type: string; // None, Now, Depart, Arrive
  date: Date; // date picker
  time: Date; // time field
  datepickerDisabled = true; // disable date picker, calendar button, time field or not
  applyTraffic = true; // use traffic or not for a route
  trafficDisabled = false; // disable traffic checkbox or not
  timeGroup: FormGroup;
  constructor(
    private routeService: RouteService,
    private authenticationService: AuthenticationService
  ) {}

  setDefaultDateTime(dt?: Date) {
    if (typeof dt === 'undefined') {
      dt = new Date();
    }
    this.date = dt;
    this.time = dt;
  }

  createFormGroup() {
    const tm = DateTime.fromJSDate(this.time);
    const timeString = tm.toLocaleString(DateTime.TIME_SIMPLE); // 1:30 PM
    const timeParts = timeString.split(' ');
    const hrMn = timeParts[0].split(':');
    const hour = parseInt(hrMn[0]);
    const minute = parseInt(hrMn[1]);
    const ampm = timeParts[1];

    return new FormGroup({
      timeControl: new FormControl(new TimeField(hour, minute, ampm)),
    });
  }

  ngOnInit(): void {
    this.isPremium$ = this.authenticationService.currentUser.pipe(
      map((user) => {
        return user?.subscriptionLevel === SubscriptionLevel.PREMIUM;
      })
    );
    const arrDepSelection = this.route.arrDepSelection;
    if (typeof arrDepSelection !== 'undefined' && arrDepSelection !== null) {
      if (
        arrDepSelection.type === this.optionsUI.arrDepTypes[2].value &&
        typeof arrDepSelection.date === 'undefined'
      ) {
        this.type = this.optionsUI.arrDepTypes[1].value; // Now
      } else {
        this.type = arrDepSelection.type;
      }
      this.applyTraffic = arrDepSelection.useTraffic;
      if (
        typeof arrDepSelection.date !== 'undefined' &&
        typeof arrDepSelection.time !== 'undefined' &&
        (this.type === this.optionsUI.arrDepTypes[3].value || // Arrive
          this.type === this.optionsUI.arrDepTypes[2].value) // Depart
      ) {
        // Arrive and depart time
        const dt = DateTime.fromFormat(
          `${arrDepSelection.date}, ${arrDepSelection.time}`,
          'f'
        );
        this.setDefaultDateTime(dt.toJSDate());
      } else {
        this.setDefaultDateTime();
      }
      this.onTypeChange(this.type);
    } else {
      this.setDefaultDateTime();
      this.type = this.optionsUI.arrDepTypes[0].value; // 'None'
      this.applyTraffic = false;
      this.trafficDisabled = true;
      this.datepickerDisabled = true;
    }
    this.timeGroup = this.createFormGroup();
  }

  setArriveDepart() {
    const timeValue = this.timeGroup.controls.timeControl.value;
    const dt = DateTime.fromJSDate(this.date);
    const dateShort = dt.toLocaleString(DateTime.DATE_SHORT);
    if (timeValue !== null) {
      const hour = timeValue.hour.toString();
      const minute = timeValue.minute.toString();
      const ampm = timeValue.ampm.toString();
      const dTime = DateTime.fromFormat(
        `${dateShort}, ${hour}:${minute} ${ampm}`,
        'f'
      );
      this.time = dTime.toJSDate();
    }
    const timeSimple = DateTime.fromJSDate(this.time).toLocaleString(
      DateTime.TIME_SIMPLE
    );
    const arrDep: ArrDepSelection = {
      date: dateShort,
      time: timeSimple,
      type: this.type,
      datetype:
        this.type === this.optionsUI.arrDepTypes[0].value // None
          ? ''
          : this.optionsUI.daydatetype[1].value, // date // because weekday is not supported by design for now.
      useTraffic: this.applyTraffic,
    };
    this.routeService.setArrivalDepartureRouteOptions(this.route.id, arrDep);
  }

  onTypeChange(type: string) {
    if (type === this.optionsUI.arrDepTypes[0].value) {
      this.applyTraffic = false;
      this.trafficDisabled = true;
      this.datepickerDisabled = true;
    } else if (type === this.optionsUI.arrDepTypes[1].value) {
      this.trafficDisabled = false;
      this.datepickerDisabled = true;
    } else {
      this.trafficDisabled = false;
      this.datepickerDisabled = false;
    }
  }

  toggleTraffic(event: PointerEvent) {
    const target = event.target as HTMLInputElement;
    this.applyTraffic = target.checked;
  }
}
